import React from 'react'
import { useInRouterContext, useNavigate } from 'react-router-dom'

// A real <a href> that moves inside the app without a page reload. It works
// outside a router too (a modal rendered alone in a test), as a plain link.
// A ctrl, shift, alt or middle click is left to the browser, so "open in a new
// tab" always works. The click never reaches a clickable row underneath.
//   - newTab: opens in a new tab (target=_blank).
//   - onOpen: replaces the navigation (a page's own modal, say).
//   - onFollow: runs after an in-app navigation (closing a modal, say).

/**
 * @param {{ href: string, newTab?: boolean, onOpen?: () => void, onFollow?: () => void,
 *           className?: string, children: React.ReactNode }} props
 */
export default function AppLink(props) {
  const inRouter = useInRouterContext()
  return inRouter ? <RoutedAnchor {...props} /> : <Anchor {...props} />
}

function RoutedAnchor(props) {
  const navigate = useNavigate()
  return <Anchor {...props} navigate={navigate} />
}

function Anchor({ href, newTab = false, onOpen, onFollow, className = '', children, navigate }) {
  function handleClick(event) {
    event.stopPropagation()
    if (isModifiedClick(event) || newTab) return
    if (onOpen) {
      event.preventDefault()
      onOpen()
      return
    }
    if (navigate) {
      event.preventDefault()
      navigate(href)
    }
    onFollow?.()
  }

  return (
    <a
      href={href}
      className={className || undefined}
      onClick={handleClick}
      {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {children}
    </a>
  )
}

function isModifiedClick(event) {
  return event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey
}
